import CautionFeedback from "@skv/assets/gfx/feedback/caution.png";
import NegativeFeedback from "@skv/assets/gfx/feedback/negative.png";
import PositiveFeedback from "@skv/assets/gfx/feedback/positive.png";

interface ErrorContactUsFragmentProps {
  title: string;
  children: React.ReactNode;
  variant: FeedbackEnum;
}

export enum FeedbackEnum {
  "Error",
  "Caution",
  "Positive",
}

export const FeedbackFragment = (props: ErrorContactUsFragmentProps) => {
  const src =
    props.variant === FeedbackEnum.Caution
      ? CautionFeedback
      : props.variant === FeedbackEnum.Positive
      ? PositiveFeedback
      : NegativeFeedback;

  return (
    <div
      role="status"
      className="d-flex flex-column align-items-center text-center mx-auto"
      css={`
        max-width: 720px;
      `}
    >
      <img
        src={src}
        className="img-fluid mb-4"
        alt=""
        width={props.variant === FeedbackEnum.Positive ? 113 : 138}
        height={138}
      />
      <h1 className="mb-4">{props.title}</h1>
      {props.children}
    </div>
  );
};
